import { render, staticRenderFns } from "./TrendyolFinansman.vue?vue&type=template&id=3470853e"
import script from "./TrendyolFinansman.vue?vue&type=script&lang=js"
export * from "./TrendyolFinansman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports